import React from 'react';
import { styled, css } from 'styled-components';
import { observer } from 'mobx-react-lite';
import { RecordingViewState } from './RecordingViewState';
import { saveRecordingFn, saveToHarFile } from '../../State/EvidenceDB/SaveRecording';
import { BorderlessButton, BorderlessCancelButton, ButtonColoring } from './common-styles';
import { downloadReport } from './downloadReport';
import { WindowRoutingState } from './WindowRoutingState';

export const HeaderTitleHeight = `1.5rem`;
export const HeaderTabsHeight = `1.5rem`;
export const HeaderVerticalPadding = `0.25rem`;
export const TotalHeaderHeightWithoutTabs = `2rem`;
export const TotalHeaderHeightWithTabs = `5rem`;

export const VerticalSpacerForHeaderWithoutTabs = styled.div`
	height: ${TotalHeaderHeightWithoutTabs};
`;

export const VerticalSpacerForHeaderWithTabs = styled.div`
	height: ${TotalHeaderHeightWithTabs};
`;

export const PageHeaderElement = styled.header`
	top: 0;
	left: 0;
	z-index: 10;
	position: fixed;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	font-size: 125%;
	padding-top: ${HeaderVerticalPadding};
	padding-bottom: ${HeaderVerticalPadding};
	background-color: rgba(248, 248, 248, 1);
`;

const HeaderRow = styled.div`
	box-sizing: border-box;
	height: ${HeaderTitleHeight};
	width: 100vw;
	padding-left: 2.5vw;
	padding-right: 2.5vw;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
`;

const HeaderTabRow = styled(HeaderRow)`
	height: ${HeaderTabsHeight};
	border-top: 1px solid rgba(128, 128, 128, 0.25);
	border-bottom: 1px solid rgba(128, 128, 128, 0.25);
	justify-content: center;
	&:first-child {
		border-left: 1px solid rgba(128, 128, 128, 0.25);
	}
	padding-top: 0;
	padding-bottom: 0;
`

const HeaderColumn = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: start;
	gap: 1rem;
`;

const HeaderTabColumn = styled.div<{$selected: boolean}>`
	display: flex;
	flex-direction: row;
	justify-content: center;
	flex-wrap: nowrap;
	flex-grow: 1;
	padding-top: 0;
	padding-bottom: 0;
	user-select: none;
	border-right: 1px solid rgba(128, 128, 128, 0.25);
	${ButtonColoring}
	${ p => p.$selected ? css`
		background-color: rgba(128, 128, 128, 0.1);
	` : ''}
`;

const BreadcrumbElement = styled.div`
	color: rgba(16, 0, 16, 1);
`;

const BreadcrumbElementSeparator = styled.span`
	/* margin-left: 1rem;
	margin-right: 1rem; */
`;

const BreadcrumbElementBack = styled(BreadcrumbElement)`
	cursor: pointer;
	color: rgba(32, 0, 32, 1);
	text-decoration-line: underline;
	text-decoration-style: solid;
	text-decoration-color: rgba(32, 0, 32, 0.1);
`;

const BreadcrumbElementCurrent = styled(BreadcrumbElement)`
`;

const SettingsElement = styled.div`
	cursor: pointer;
	color: rgba(32, 0, 32, 1);
	/* margin-block-end: 0.5rem; */
`;


export const RecordingsPageHeaderView = observer( ({windowRoutingState}: {windowRoutingState: WindowRoutingState}) => {
	return (<>
		<PageHeaderElement>
			<HeaderRow>
				<HeaderColumn>
					<BreadcrumbElementCurrent>Recordings</BreadcrumbElementCurrent>
				</HeaderColumn>
				<HeaderColumn>
					<SettingsElement onClick={ () => { windowRoutingState.pushPage("settings") } } >⚙️</SettingsElement>
				</HeaderColumn>
			</HeaderRow>
		</PageHeaderElement>
		<VerticalSpacerForHeaderWithoutTabs />
	</>)
});

const DropdownMenuContainer = styled.div`
	position: relative;
  display: inline-block;
`;


const DropdownMenuTitleButton = styled.button`
	background-color: rgba(0, 0, 0, 0);
	user-select: none;
	border: none;
	color: rgba(0, 0, 0, 0.5);
	cursor: pointer;
	font-size: 1rem;
	&:hover {
		background-color: #f1f1f1;
	};
`;

const DropdownMenuContent = styled.div`
  display: none;
  position: absolute;
	flex-direction: column;
	align-items: start;
	min-width: 5rem;
	right: 0;
  background-color: #f1f1f1;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
	${DropdownMenuContainer}:hover & {
    display: flex;
		z-index: 16;
  }
`;


const NameInput = styled.input.attrs({type: "text"})`
	min-width: 12.5rem;
`;

const DropdownMenuItem = styled.button`
  display: block;
	border: none;
	user-select: none;
	color: black;
  padding: 0.5rem 0.5rem;
  text-decoration: none;
	${ButtonColoring}
`

export const RecordingMenu = observer( ({recordingViewState}: {recordingViewState: RecordingViewState}) => {
	return (
		<DropdownMenuContainer>
		<DropdownMenuTitleButton>File</DropdownMenuTitleButton>
		<DropdownMenuContent>
			{/* <DropdownMenuItem onClick={ downloadStandaloneSearchReportFn(recordingViewState) }>
				Download Search Report
			</DropdownMenuItem> */}
			<DropdownMenuItem onClick={() => downloadReport(recordingViewState)}>
				Download &nbsp; {recordingViewState.reportBaseName}
			</DropdownMenuItem>
			<DropdownMenuItem onClick={() => saveToHarFile(recordingViewState.recordingUuid)}>
				Save HAR
			</DropdownMenuItem>
			<DropdownMenuItem onClick={ saveRecordingFn(recordingViewState.recordingUuid) }>
				Save All
			</DropdownMenuItem>
		</DropdownMenuContent>
	</DropdownMenuContainer>
	)
});

export const SearchTabsView = observer( ({recordingViewState}: {recordingViewState: RecordingViewState}) => {
	return (<>
	<HeaderTabRow>
		<HeaderTabColumn $selected={recordingViewState.searchTab === 'chronological'} onClick={ recordingViewState.setSearchTabFn('chronological') }>Chronological</HeaderTabColumn>
		<HeaderTabColumn $selected={recordingViewState.searchTab === 'by search term'} onClick={ recordingViewState.setSearchTabFn('by search term') }>By Search Term</HeaderTabColumn>
		<HeaderTabColumn $selected={recordingViewState.searchTab === 'by destination'} onClick={ recordingViewState.setSearchTabFn('by destination') }>By Destination</HeaderTabColumn>
	</HeaderTabRow>
	</>);
});

export const ReportsTabsView = observer( ({recordingViewState}: {recordingViewState: RecordingViewState}) => {
	return (<>
	<HeaderTabRow>
		<HeaderTabColumn $selected={recordingViewState.reportTab === 'tracking'} onClick={ recordingViewState.setReportTabFn('tracking') }>Tracking Summary</HeaderTabColumn>
		<HeaderTabColumn $selected={recordingViewState.reportTab === 'instrumentation'} onClick={ recordingViewState.setReportTabFn('instrumentation') }>Instrumentation</HeaderTabColumn>
	</HeaderTabRow>
	</>);
});
	

export const TabsView = observer( ({recordingViewState}: {recordingViewState: RecordingViewState}) => {
	return (<>
	<HeaderTabRow>
		<HeaderTabColumn $selected={recordingViewState.topTab === 'search'} onClick={ recordingViewState.setTopTabFn('search') }>Search</HeaderTabColumn>
		<HeaderTabColumn $selected={recordingViewState.topTab === 'reports'} onClick={ recordingViewState.setTopTabFn('reports') }>Other Reports</HeaderTabColumn>
	</HeaderTabRow>{ recordingViewState.topTab === 'search' ? (<SearchTabsView recordingViewState={recordingViewState} />) :
		recordingViewState.topTab === 'reports' ? (<ReportsTabsView recordingViewState={recordingViewState} />) :
		null }
	</>)});


export const RecordingPageHeaderView = observer( ({recordingViewState}: {recordingViewState: RecordingViewState}) => {
	const [nameInEditBox, setNameInEditBox] = React.useState<string | undefined>();
	const saveName = () => {
		if (nameInEditBox != null) {
			console.log(`Changing name to ${nameInEditBox}`);
			recordingViewState.setRecordingName(nameInEditBox);
			setNameInEditBox(undefined);
		}
	}
	const cancelNameEdit = () => {
		setNameInEditBox(undefined);
	}
	const goToRecordingsPage = () => {
		if (window.history.length > 1) {
			window.history.back()
		} else {
			recordingViewState.windowRoutingState.pushPage("recordings");
		}
	}
	return (<>
		<PageHeaderElement>
			<HeaderRow>
				<HeaderColumn>
					<BreadcrumbElementBack onClick={goToRecordingsPage}>Recordings</BreadcrumbElementBack>
					<BreadcrumbElementSeparator>→</BreadcrumbElementSeparator>
					<BreadcrumbElementCurrent>
						{ nameInEditBox != null ?  (<>
							<NameInput
								defaultValue={nameInEditBox}
								placeholder={recordingViewState.dbRecordingEntryWriter?.nameOrDescription}
								onChange={ (e) => setNameInEditBox(e.currentTarget.value) }
								onKeyDown={ (e) => { if (e.key === 'Enter') { saveName(); } } }
								/>
							<BorderlessButton onClick={ saveName }>✓</BorderlessButton>
							<BorderlessCancelButton onClick={ cancelNameEdit }>✗</BorderlessCancelButton>
						</>) : recordingViewState.dbRecordingEntryWriter?.nameOrDescription }
						<BorderlessButton 
							hidden={ nameInEditBox != null }
							onClick = { () => setNameInEditBox(recordingViewState.recordingName ?? "")
						}>✎</BorderlessButton>
					</BreadcrumbElementCurrent>
				</HeaderColumn>
				<HeaderColumn>
					<RecordingMenu recordingViewState={recordingViewState} />
					<SettingsElement onClick={ () => { recordingViewState.windowRoutingState.pushPage("settings") } } >⚙️</SettingsElement>
				</HeaderColumn>
			</HeaderRow>
			<TabsView recordingViewState={recordingViewState} />
		</PageHeaderElement>
		<VerticalSpacerForHeaderWithTabs />
		</>)
});
